var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
		'background-color': _vm.$vuetify.theme.dark ? '#242424' : '#f2f3f8'
	})},[_c('Loading',{ref:"Loading"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }